import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardByIdController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
const GetTemplateDashboardByIdController = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardByIdController.url(args, options),
    method: 'get',
})

GetTemplateDashboardByIdController.definition = {
    methods: ["get","head"],
    url: '/api/template-dashboard/{template_dashboard}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardByIdController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
GetTemplateDashboardByIdController.url = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
    }

    return GetTemplateDashboardByIdController.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardByIdController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
GetTemplateDashboardByIdController.get = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardByIdController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardByIdController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
GetTemplateDashboardByIdController.head = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTemplateDashboardByIdController.url(args, options),
    method: 'head',
})

export default GetTemplateDashboardByIdController